import _property from 'lodash/property';
import _get from 'lodash/get';
export var getHexCodeOptionLabel = function getHexCodeOptionLabel() {
  var colorObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _get(colorObject, 'displayValue');
};
var getHexCodeOptionValue = _property('displayValue');
export var VEHICLE_EXTERIOR_COLOR_HEXCODE = {
  getOptionLabel: getHexCodeOptionLabel,
  getOptionValue: getHexCodeOptionValue
};